import { Action } from 'redux';

import { EditPredictiveModel } from '../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { ISpaceItemDetailInfo } from '../../spacesPlatform/models/ISpaceItemDetailInfo';

export interface EditPredictiveModelReduxAction extends Action {
  readonly predictiveModel: IContentInfo;
}

export function editPredictiveModel(predictiveModel: IContentInfo | ISpaceItemDetailInfo<'predictiveModel'>): EditPredictiveModelReduxAction {
  return {
    type: EditPredictiveModel,
    predictiveModel
  };
}
